export default __webpack_public_path__ + "static/media/Ct8.fd236ab9.png";